import { VotingConstants } from "../../constants/voting.constants";

export const gotAdressesByCompany = (addresses) => {
	return {
		type: VotingConstants.GET_ADDRESSES_BY_COMPANY,
		payload: addresses,
	};
};

export const loadingAddresses = () => {
	return {
		type: VotingConstants.LOADING_ADDRESSES,
	};
};
